import { SortMenuItemDirection } from '@/types';

export interface SortMenuItem {
    label: string;
    key: string;
    direction?: SortMenuItemDirection;
}
